import { DateTime } from 'luxon';

import { ApjLicenseLabel, STODocumentStatusEnum } from 'commons/enums';
import { ICompanyInfo, OrderType, STODocument } from 'commons/types';
import {
  IRenderedSTOItem,
  ISTOInvoiceMappedData,
} from 'pages/sto-print-template/invoice-template/interfaces';

const TABLE_CHUNK = 15;

export const mapSTOInvoicePrintData = (
  stoDocument: STODocument,
  fromWarehouse: ICompanyInfo | null,
  toWarehouse: ICompanyInfo | null,
  tableChunk: number = TABLE_CHUNK,
): ISTOInvoiceMappedData => {
  const tableData: IRenderedSTOItem[][] = [];
  const items =
    stoDocument.items
      ?.map((item) => {
        const itemPickActual = item.pick_actual || [];
        return itemPickActual.reduce<IRenderedSTOItem[]>(
          (res, pickActual) => [
            ...res,
            {
              sku_code: item.sku_code,
              name: item.name,
              quantity: pickActual.quantity,
              uom: item.uom || '',
              inventory: pickActual.inventory_number || '',
              expiry_date: DateTime.fromISO(
                pickActual.expiry_date as unknown as string,
              ).toFormat('LL-yyyy'),
              price: item.transfer_price,
              net_price: item.transfer_price * pickActual.quantity,
            },
          ],
          [],
        );
      })
      .flat() || [];
  for (let i = 0; i < items.length; i += tableChunk) {
    const chunk = items.slice(i, i + tableChunk);
    tableData.push(chunk);
  }

  const apjOrderType = stoDocument.is_alkes
    ? OrderType.ALKES
    : stoDocument.is_oot
    ? OrderType.OOT
    : stoDocument.is_prekursor
    ? OrderType.PRECURSOR
    : OrderType.REGULAR;
  const apjData = fromWarehouse?.apj[apjOrderType];

  return {
    sto_number: stoDocument.sto_number || '',
    invoice_date: DateTime.fromISO(
      stoDocument.status_history[
        STODocumentStatusEnum.SHIPPED
      ] as unknown as string,
    ).toFormat('dd/MM/yyyy'),
    to_warehouse_address: toWarehouse?.address || '',
    to_warehouse_name: toWarehouse?.name || '',
    total_amount: tableData.reduce(
      (total, data) =>
        total +
        data.reduce((totalForItem, item) => totalForItem + item.net_price, 0),
      0,
    ),
    is_alkes: stoDocument.is_alkes,
    is_oot: stoDocument.is_oot,
    is_prekursor: stoDocument.is_prekursor,
    items: tableData,
    from_warehouse_info: toWarehouse && {
      name: fromWarehouse?.name || '',
      address: fromWarehouse?.address || '',
      pbf_no: fromWarehouse?.pbf_no || '',
      dak_no: fromWarehouse?.dak_no || '',
      cdob_no: fromWarehouse?.cdob_no || '',
      cdakb_no: fromWarehouse?.cdakb_no || '',
      cdob_ccp_no: fromWarehouse?.cdob_ccp_no || '',
      apj_title: stoDocument.is_alkes ? 'PJT' : 'APJ',
      apj_signature: apjData?.stamped_signature || '',
      apj_name: apjData?.name || '',
      apj_sipa: apjData?.sipa || '',
      apj_license_label: stoDocument.is_alkes
        ? ApjLicenseLabel.IJAZAH
        : ApjLicenseLabel.STRA,
    },
  };
};
